import request from 'superagent'
import { each } from 'lodash'

import store from '../store'
import router from '../router'

const timeout = 30 * 1000 // Default timeout is 30 seconds

export default function (method, headers = {}, url, data, options = {}) {
  return new Promise((resolve, reject) => {
    const req = request[method](url)

    each(headers, (value, key) => {
      req.set(key, value)
    })

    if (method === 'post' || method === 'put' || method === 'del' || method === 'patch') {
      if (options.delivery === 'formData') {
        each(data, (value, key) => {
          if (!value) { return }

          if (value.name && value.mimeType) {
            req.attach(key, value.content)
          } else {
            req.field(key, value)
          }
        })
      } else {
        req.send(data)
      }
    }

    req.timeout(options.timeout || timeout)

    req.end((err, res) => {
      if (!err && (res.status === 200 || res.status === 201 || res.status === 204)) {
        if (res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          return resolve(res.text)
        }
        return resolve(res.body)
      }

      if (!res) {
        return reject(new Error('Couldn\'t connect to the server'))
      }

      if (res.status === 401) {
        store.dispatch('logout')
        router.push('/login')
      }

      var message
      if (res.body && res.body.message) {
        message = res.body.message
      } else {
        message = err.message
      }

      const e = {
        method,
        url,
        status: err.status,
        message
      }

      return reject(e)
    })
  })
}
